import { render, staticRenderFns } from "./jogo.vue?vue&type=template&id=8ab37cb4&"
import script from "./jogo.vue?vue&type=script&lang=js&"
export * from "./jogo.vue?vue&type=script&lang=js&"
import style0 from "./jogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports